<template>
  <a-card>
    <a-tabs v-model:activeKey="activeKey">
      <a-tab-pane key="1" tab="工作经历">
        <workExprise />
      </a-tab-pane>
      <a-tab-pane key="2" tab="教育经历">
        <eduExprise />
      </a-tab-pane>
      <a-tab-pane key="3" tab="项目经验">
        <projectExprise/>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>

<script>
import workExprise from './workExprise';
import eduExprise from './eduExprise';
import projectExprise from './projectExprise';
export default {
  name: "index",
  components: {
    workExprise, eduExprise, projectExprise
  },
  data() {
    return {
      activeKey: '1'
    }
  },
  methods: {

  }
}
</script>

<style scoped></style>
